const common = {
	APP_NAME: "PSI | Events",
	APP_COPYRIGHT: "PSI",
	APP_VERSION: "1.0",
	APP_MODE: process.env.VUE_APP_MODE,
};

const production = {
	BACKEND_URL: "https://events.psi.fr/",
	BACKEND_URL_API_PREFIX: "/api",
	DEBUG: false,
};

const integration = {
	BACKEND_URL: "https://api.events.integration.quietamstudio.fr/",
	BACKEND_URL_API_PREFIX: "/api",
	DEBUG: true,
};

const development = {
	BACKEND_URL: "http://127.0.0.1:8000/",
	BACKEND_URL_API_PREFIX: "/api",
	DEBUG: true,
};

switch(process.env.VUE_APP_MODE) {
	case "production":
		Object.assign(common, production);
		break;
	case "integration":
		Object.assign(common, integration);
		break;
	default:
		Object.assign(common, development);
}

export default common;
